import { Record } from 'immutable';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import Image from '@famly/vet_common_image';
class InstitutionSetting extends Record({
    setting: '',
    value: false,
}) {
}
export class StatusStats extends Record({
    SICK: 0,
    VACATION: 0,
    ABSENT: 0,
    SLEEPING: 0,
    ON_BUS: 0,
    ON_TRIP: 0,
    CHILD_SICK: 0,
}) {
}
export class PeopleStats extends Record({
    checkedIn: 0,
    total: 0,
    expected: 0,
    status: new StatusStats(),
}) {
}
export const peopleStatsFromAPI = stats => new PeopleStats({
    ...stats,
    status: new StatusStats(stats.status),
});
class CustomStatusConfig extends Record({
    statusConfigId: '',
    color: '',
    createdAt: '',
    forChildren: false,
    forEmployees: false,
    icon: '',
    institutionId: '',
    title: '',
}) {
}
export class CustomStatusStats extends Record({
    count: 0,
    statusConfig: new CustomStatusConfig(),
}) {
}
export const customStatusStatsFromAPI = stats => new CustomStatusStats({
    count: stats.count,
    statusConfig: new CustomStatusConfig(stats.statusConfig),
});
export class Group extends Record({
    departmentId: '',
    groupId: '',
    title: '',
    image: Image.default,
    behaviors: new BehaviorsCollection([]),
    childCount: undefined,
    staffCount: undefined,
    capacity: undefined,
    color: undefined,
    deletedAt: undefined,
    famlyId: '',
    info: '',
    institutionId: '',
    phone: '',
    requirePickupInfo: false,
    staffRatio: undefined,
    starred: false,
    starring: false,
    settings: undefined,
    stats: undefined,
    statusRegistrationStats: undefined,
}) {
}
export function fromAPI(data) {
    return new Group({
        ...data,
        behaviors: new BehaviorsCollection(data.behaviors),
        childCount: data.stats && data.stats.children ? data.stats.children.total : undefined,
        staffCount: data.stats && data.stats.employees ? data.stats.employees.total : undefined,
        stats: data.stats
            ? {
                children: data.stats.children ? peopleStatsFromAPI(data.stats.children) : undefined,
                employees: data.stats.employees ? peopleStatsFromAPI(data.stats.employees) : undefined,
            }
            : undefined,
        statusRegistrationStats: data.statusRegistrationStats
            ? {
                children: data.statusRegistrationStats.children
                    ? data.statusRegistrationStats.children.map(customStatusStatsFromAPI)
                    : undefined,
                employees: data.statusRegistrationStats.employees
                    ? data.statusRegistrationStats.employees.map(customStatusStatsFromAPI)
                    : undefined,
            }
            : undefined,
        image: Image.fromAPI(data.image),
        settings: data.settings ? data.settings.map(setting => new InstitutionSetting(setting)) : undefined,
    });
}
export default {
    fromAPI,
    Group,
};
